import { makeStyles } from '@mui/styles';
import FieldGroup from 'apollo-react/components/FieldGroup';
import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';

import { useFormSelector } from '../../../custom-hooks';
import { getUITA } from '../../../utils/commonUtils';
import NewComponent from '../../components/editor/components/NewComponent';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import { getEvaluatedExpression } from '../../selectors/form-manager.selectors';
import { getChildrenTypes } from '../../selectors/runtime.selectors';
import { renderElement } from '../../utils/controls/ssFieldGroup.utils';

const useStyles = makeStyles({
  root: {
    overflowWrap: 'anywhere',
    '& *': {
      overflowWrap: 'anywhere !important',
    },
  },
  horizontalContainer: {
    backgroundColor: '#fff',
    '& > :last-child': {
      display: 'flex',
      '& > div': {
        flex: '1 !important',
        marginLeft: 15,
        '&:first-of-type': {
          marginLeft: 0,
        },
      },
    },
  },
  controlContainer: {
    position: 'relative',
    margin: '16px 0 !important',
    minHeight: 40,
    width: 568,
    '& input': {
      width: ({ isEditor }) => `${isEditor ? '100%' : 156}`,
    },
    '& h3': {
      fontSize: 16,
    },
  },
  content: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: ({ isHorizontal }) => `${isHorizontal ? 'row' : 'column'}`,
    '& > div': {
      paddingRight: ({ isHorizontal }) => `${isHorizontal ? '20px !important' : 0}`,
    },
    '& [ui-ta*="SSZoom"]': {
      zIndex: 10,
    },
    '& [ui-ta*="SSSegmentFieldSet"]': {
      width: ({ isHorizontal }) => `${isHorizontal ? '' : '100%'}`,
    },
  },
  noHeader: {
    padding: '24px 0',
  },
});

const SSRuntimeFieldGroup = ({ children, id, index, orientation, isEditor }) => {
  const title = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    prop: FORM_MODEL_ATTRIBUTES.TITLE,
  });
  const childrenTypes = useFormSelector(getChildrenTypes, { id });

  const isHorizontal = ['HORIZONTAL', 'HORIZONTALWITHOUTLABEL'].includes(orientation);
  const isHiddenLabel = _.isEqual('HORIZONTALWITHOUTLABEL', orientation);
  const classes = useStyles({ isHorizontal, isEditor });

  return (
    <span className={classes.root} ui-ta={getUITA('SSFieldGroup', orientation)} data-ss-id={id}>
      <FieldGroup
        header={title}
        className={classnames([
          classes.controlContainer,
          isHorizontal && !isEditor ? classes.horizontalContainer : '',
          !title ? classes.noHeader : '',
        ])}
      >
        <div className={!isEditor && classnames([classes.content])}>
          {React.Children.map(children, renderElement(childrenTypes, isHiddenLabel, children))}
          {isEditor && !children.length && (
            <NewComponent controlParentId={id} previousControlId="" />
          )}
        </div>
      </FieldGroup>
    </span>
  );
};

export default SSRuntimeFieldGroup;
